import React, { useState } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { expressURL } from '../../utils/networkUtils';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${expressURL()}/auth/forgot-password`, { email });
      setMessage(typeof response.data === 'string' ? response.data : 'If that email is in the app, we sent a reset link.');
    } catch (error) {
      const detail = error.response?.data;
      const text = typeof detail === 'string' ? detail : (detail?.error || error.message || 'unknown error');
      setMessage('Error: ' + text);
    }
  };

  return (
    <div className='main-content'>
      <Container className='mb-5'>
        <h1 className="display-4 mb-3 mt-3">Forgot password</h1>
        <form onSubmit={handleSubmit}>
          <Row>
            <Col sm={3} md={2} xxl={1}>
              <Form.Label>Email address</Form.Label>
            </Col>
            <Col className='mb-3'>
              <Form.Control
                type="email"
                autoComplete="username"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Col>
          </Row>
          <button className='btn btn-primary' type="submit">Send reset link</button>
        </form>
        {message && <p className="mt-3">{message}</p>}
        <p className="mt-3"><Link to="/login">Back to login</Link></p>
      </Container>
    </div>
  );
}

export default ForgotPassword;
